var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-global-header__container" }, [
    _c("div", {
      staticClass:
        "c-global-header__placeholder j-global-header__placeholder-height"
    }),
    _vm._v(" "),
    _c("div", { staticClass: "c-global-header j-global-header-height" }, [
      _vm.hasBannerSlot
        ? _c(
            "div",
            {
              staticClass:
                "c-global-header__banner t-heading-6 j-header__banner-height"
            },
            [_vm._t("banner")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-global-header__menu l-grid j-header__menu-height",
          class: { "l-container": !_vm.isMobile }
        },
        [
          !_vm.isMobile
            ? _c("DesktopNav", {
                ref: "j-header__desktop-nav",
                attrs: {
                  "is-mobile": _vm.isMobile,
                  "open-id": _vm.openId,
                  "main-nav": _vm.mainNav
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "MobileNav",
                {
                  ref: "j-header__mobile-nav",
                  attrs: {
                    "is-mobile": _vm.isMobile,
                    "open-id": _vm.openId,
                    "main-nav": _vm.mainNav,
                    "footer-nav": _vm.footerNav,
                    "find-your-ring": _vm.findYourRing
                  }
                },
                [
                  _vm._l(_vm.$slots, function(_, name) {
                    return _vm._t(name, null, { slot: name })
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "u-text-align-center" },
            [
              _c("nuxt-link", { attrs: { to: "/" } }, [
                _vm.image
                  ? _c("img", {
                      staticClass: "c-global-header__logo",
                      attrs: { src: _vm.image.src, alt: _vm.image.alt }
                    })
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "UtilityNav",
            {
              staticClass: "u-text-align-right",
              attrs: {
                "main-nav": _vm.mainNav,
                "is-mobile": _vm.isMobile,
                "find-your-ring": _vm.findYourRing
              }
            },
            [
              _vm._l(_vm.$slots, function(_, name) {
                return _vm._t(name, null, { slot: name })
              })
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }